import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const submitLead = (data) =>
  axios.post(`${API}/leads`, data).then((r) => r.data);

export const fetchLeads = () => axios.get(`${API}/leads`).then((r) => r.data);

export const openBooking = () => window.dispatchEvent(new Event("open-booking"));
